module.exports = __webpack_public_path__ + "static/img/firstPageBanner.33fb2c05.png";